import Lenis from "@studio-freight/lenis";
import gsap from 'gsap';
import { ScrollTrigger } from "gsap/ScrollTrigger.js";
import "splitting/dist/splitting.css";
import "splitting/dist/splitting-cells.css";
import Splitting from 'splitting';

gsap.registerPlugin(ScrollTrigger);
const animations = {
    init()  {

        // Function to check if the current browser is Safari
        function isSafari() {
            return /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
        }

        // Initialize and use Lenis only if it's not Safari
        if (!isSafari()) {
            let lenis;
            lenis = new Lenis({
                duration: 0.8,
            });

            lenis.on('scroll', () => ScrollTrigger.update());

            function raf(time) {
                lenis.raf(time);
                requestAnimationFrame(raf)
            }

            requestAnimationFrame(raf);
        }
    }
}

export {animations}